import { useTranslation } from 'react-i18next';

import { type BuilderViewKey } from '@/types/schema/BuilderView';
import { CollapsiblePanel } from '@/components/layout/CollapsiblePanel';
import { usePageEditorContext } from '@/pages/pages/page-editor/PageEditorContext';
import { ActiveViewContextProvider } from './ActiveViewContextProvider';
import { FormSettings } from './form/FormSettings';
import { RichTextSettings } from './rich-text/RichTextSettings';

interface ViewSettingsProps {
  viewKey: BuilderViewKey;
}

export function ViewSettings({ viewKey }: ViewSettingsProps) {
  const [t] = useTranslation();
  const { page } = usePageEditorContext();

  // Get the view from the page editor's active page, so we always have the most up-to-date view
  const view = page.views.find((v) => v.key === viewKey);

  if (!view) {
    return null;
  }

  const getViewSettingsContent = () => {
    switch (view.type) {
      case 'form':
        return <FormSettings />;
      case 'rich_text':
        return <RichTextSettings />;

      // More views will be added here as they get implemented
      default:
        return (
          <CollapsiblePanel.Content title={t('pages.element_settings.heading')}>
            Coming Soon
          </CollapsiblePanel.Content>
        );
    }
  };

  return (
    <ActiveViewContextProvider view={view}>{getViewSettingsContent()}</ActiveViewContextProvider>
  );
}
